export default "__VITE_ASSET__D6KbU7zo__"